import { render, staticRenderFns } from "./BirthdayThisMonth.vue?vue&type=template&id=00df98ea&"
import script from "./BirthdayThisMonth.vue?vue&type=script&lang=js&"
export * from "./BirthdayThisMonth.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayThisMonth.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports